<template lang="pug">
.fw--dialog(v-if="isOpen")
  .fw--dialog-box
    header
      h2 {{ header }}
      p {{ message }}
    footer
      button.button.primary-button(ref="confirm", type="button", @click="confirm()") Confirm
      button.button(type="button", @click="close") Cancel
</template>

<script>

export default {
  name: 'DialogBox',
  props: {
    programmatic: Boolean,
    type: String,
    header: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    onConfirm: {
      type: Function,
      default: () => {}
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: this.open
    }
  },
  beforeMount() {
    // Insert the Modal component in body tag
    // only if it's programmatic
    //console.log(this.programmatic)
    this.programmatic && document.body.appendChild(this.$el)
  },
  mounted () {
    if (typeof window !== 'undefined') {
      document.addEventListener('keyup', this.keyPress)
    }
    this.$refs.confirm.focus()
    if (this.programmatic) this.isOpen = true
  },
  computed: {
  },
  methods: {
    toggle () {
      this.isOpen = !this.isOpen

      if (this.isOpen) {
        this.$emit('openDialog')
      } else {
        this.$emit('closeDialog')
      }
    },
    close () {
      //this.$emit('closeDialog')
      this.isOpen = false
      // Timeout for the animation complete before destroying
      if (this.programmatic) {
          //this.isActive = false
          setTimeout(() => {
              this.$destroy()
              this.$el.parentNode.removeChild(this.$el)
          }, 150)
      }
    },
    confirm () {
      this.onConfirm(true)
      this.close()
    },
    keyPress (e) {
      if (this.isOpen && event.keyCode === 27) this.close()
      if (this.isOpen && event.keyCode === 13) this.confirm()
    }
  },
  watch: {
    open: function (val) {
      //console.log('manual close = ' + val);
      this.isOpen = val
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
        document.removeEventListener('keyup', this.keyPress)
    }
  }
}
</script>

<style scoped lang="stylus">
.fw--dialog
  align-items center
  background-color rgba(0,0,0,.5)
  display flex
  font-family 'Avenir', Helvetica, Arial, sans-serif
  left 0
  height 100vh
  justify-content center
  position fixed
  top 0
  width 100vw
  z-index 10000
  .fw--dialog-box
    background-color $background-color
    border-radius $border-radius * 2
    //border 1px solid $border-color
    //box-shadow 0 0 10px 0 rgba(0,0,0,.5)
    //height 200px
    max-width 400px
    padding 70px
    text-align center
  header
    margin-bottom $spacing-3
    h2
      margin-bottom $spacing-2
    p
      color $text-light
      
</style>
